import { render } from "./audioPlayer.vue?vue&type=template&id=b5d8febe&scoped=true"
import script from "./audioPlayer.vue?vue&type=script&lang=js"
export * from "./audioPlayer.vue?vue&type=script&lang=js"

import "./audioPlayer.vue?vue&type=style&index=0&id=b5d8febe&lang=scss&scoped=true"
import "./audioPlayer.vue?vue&type=style&index=1&id=b5d8febe&lang=scss"
script.render = render
script.__scopeId = "data-v-b5d8febe"

export default script